import React from "react";
import { Box, Checkbox, ClickAwayListener, FormControlLabel, Grid, Table, TableBody, TableCell, TableRow, Typography } from "@material-ui/core";

import WarningIconBlack from "../../assets/svg/WarningIconBlack.svg";
import ZoomOut from "../../assets/svg/ZoomOut.svg";
import ExpandMoreIcon from "../../assets/svg/ExpandAccordionIcon.svg";
import EmailIcon from "../../assets/svg/email.svg";
import CloseIcon from "../../assets/svg/CloseIcon.svg";

import { ALL_RESULTS_FILTERED, PLEASE_RESET_TRY_AGAIN, PLEASE_CLEAR_ALL_FILTERS_TRY_AGAIN, NO_DATA_PRESENT_ERROR } from "../../../utils/MessageUtils";
import { MAP_MARKER_INTERFACE, ServiceTypeDetailsInterface } from "../../PlolygonServices/Utils/PlolygonServicesInterface";
import { capitalizeFirstLetter, isArrayValid, isEmptyOrNull, isNonEmptyObject, isUndefined } from "../../../utils/DataUtils";

/** GetNoDataPresentAfterSearchApplied */
export const GetNoDataPresentAfterSearchApplied = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <img src={WarningIconBlack} alt="Edit" />
      </Grid>
      <Grid item xs={12}>
        <Typography> {`${ALL_RESULTS_FILTERED}`}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography> {`${PLEASE_CLEAR_ALL_FILTERS_TRY_AGAIN}`}</Typography>
      </Grid>
    </Grid>
  );
};

/** GetNoDataPresentAfterFiltereApplied */
export const GetNoDataPresentAfterFiltereApplied = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <img src={WarningIconBlack} alt="Edit" />
      </Grid>
      <Grid item xs={12}>
        <Typography> {`${ALL_RESULTS_FILTERED}`}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography> {`${PLEASE_RESET_TRY_AGAIN}`}</Typography>
      </Grid>
    </Grid>
  );
};

/** GetNoDataPresentErrorViewUtils */
interface GetNoDataPresentErrorViewUtilsInterface {
  currentCountry: any;
  ErrorMessage: any;
  SecondaryErrorMessage?: any;
}
export const GetNoDataPresentErrorViewUtils = (props: GetNoDataPresentErrorViewUtilsInterface) => {
  const { currentCountry, ErrorMessage, SecondaryErrorMessage } = props;

  return (
    <Grid container>
      <Grid item xs={12}>
        <img src={ZoomOut} alt="Edit" />
      </Grid>
      <Grid item xs={12}>
        <Typography> {`${ErrorMessage || NO_DATA_PRESENT_ERROR} ${currentCountry?.name || "country"}`}</Typography>
      </Grid>
      {SecondaryErrorMessage !== undefined && SecondaryErrorMessage !== "" && (
        <Grid item xs={12}>
          <Typography> {`${SecondaryErrorMessage}`}</Typography>
        </Grid>
      )}
    </Grid>
  );
};

export const ExpandMoreAccordianIcon = () => {
  return <img src={ExpandMoreIcon} alt="Expand Accordion Icon" />;
};

interface RenderEmailIconInterface {
  classes?: any;
}
export const RenderEmailIcon = (props: RenderEmailIconInterface) => {
  const { classes } = props;
  return <img src={EmailIcon} alt="Email Icon" className={classes.emailIcon || {}} />;
};

interface PolygonInfoWindowViewUtilsInterface {
  classes: any;
  polygonRecord: any;
  handlePolygonInfoWindowClose: any;
  serviceList: any[];
}

export const PolygonInfoWindowViewUtils = (props: PolygonInfoWindowViewUtilsInterface) => {
  const { classes, polygonRecord, handlePolygonInfoWindowClose, serviceList } = props;

  const getRowSpan = (serviceName: string) => {
    const mapping = polygonRecord?.serviceTypeMapping?.[serviceName];
    return mapping?.length ?? 1;
  }

  const renderPolygonMappingDetails = (serviceObj: any) => {
    const serviceName = serviceObj?.name;
    const polygonServiceTypeDetails = polygonRecord.serviceTypeMapping[serviceName];

    if (isUndefined(serviceName) || isUndefined(polygonServiceTypeDetails) || !isArrayValid(polygonServiceTypeDetails)) {
      return <Typography>{`-`}</Typography>;
    }

    return (
      <>
        {polygonServiceTypeDetails.map((item: ServiceTypeDetailsInterface, itemIndex: number) => {
          const { isServiceable, posNo, posName, zoneName } = item;
          if (!isServiceable) {
            return (
              <Typography key={`${itemIndex}-${serviceName}-serviceTypeMapping`} className={classes.polygonInfoWindowErrorSpanStyle}>
                {`Non Serviceable`}
              </Typography>
            );
          } else {
            return (
              <Typography key={`${itemIndex}-${posNo}-${posName}-${zoneName}-serviceTypeMapping`} className={classes.polygonInfoWindowSpanStyle}>
                {`${posNo} ${posName} - ${zoneName}`}
              </Typography>
            );
          }
        })}
      </>
    );
  };

  return (
    <Box className={classes.polygonInfoWindowBoxStyle}>
      <Grid container>
        <Grid item xs={10} className={classes.polygonInfoWindowMainGridItemStyle}>
          <Typography className={classes.polygonInfoWindowTitleTextStyle}>{`${polygonRecord?.polygonId}`}</Typography>
        </Grid>
        <Grid item xs={2} className={classes.polygonInfoWindowMainGridCloseIconStyle} onClick={(event: any) => handlePolygonInfoWindowClose(event)}>
          <img src={CloseIcon} alt={CloseIcon} />
        </Grid>
        <Grid item xs={12}>
          <Table>
            <TableBody>
              {!isUndefined(serviceList) && isArrayValid(serviceList) ? (
                serviceList.map((serviceObj: any, serviceObjIndex: number) => (
                  <TableRow className={classes.polygonPopUpTableRowStyle} key={`${serviceObjIndex}-objectKeyIndex-serviceType-${serviceObj.name}`}>
                    <TableCell className={classes.polygonPopUpTableCellStyle} rowSpan={getRowSpan(serviceObj?.name ?? "")}>
                      <Typography className={classes.polygonInfoWindowTitleTextStyle}>{`${serviceObj?.displayName ?? capitalizeFirstLetter(serviceObj?.name)}`}</Typography>
                    </TableCell>
                    <TableCell className={classes.polygonPopUpTableCellStyle}>
                      {renderPolygonMappingDetails(serviceObj)}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} className={classes.polygonInfoWindowNoDataCellStyle}>
                    <Typography className={classes.polygonPopUpTableErrorTextStyle}>{`No Service Type Mapping Present`}</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

        </Grid>
      </Grid>
    </Box>
  );
};

interface PolygonPosZoneInfoWindowViewUtilsInterface {
  classes: any;
  marker: MAP_MARKER_INTERFACE;
  selectServiceTypeClick: any;
  closePolygonPosZoneInfoWindow: (event: any) => void;
  selectServiceZoneTypeClick: any;
}

export const PolygonPosZoneInfoWindowViewUtils = (props: PolygonPosZoneInfoWindowViewUtilsInterface) => {
  const { classes, marker, selectServiceTypeClick, closePolygonPosZoneInfoWindow, selectServiceZoneTypeClick } = props;

  return (
    <ClickAwayListener onClickAway={(event: any) => closePolygonPosZoneInfoWindow(event)}>
      <div>
        <Box className={classes.polygonInfoWindowBoxStyle}>
          <Grid container>
            <Grid item xs={10} className={classes.polygonInfoWindowMainGridItemStyle}>
              <Typography className={classes.polygonInfoWindowTitleTextStyle}>{`${marker?.posName}`}</Typography>
            </Grid>
            <Grid item xs={2} className={classes.polygonInfoWindowMainGridCloseIconStyle} onClick={(event: any) => closePolygonPosZoneInfoWindow(event)}>
              <img src={CloseIcon} alt={CloseIcon} />
            </Grid>
            {marker?.serviceTypes &&
              isArrayValid(marker.serviceTypes) &&
              marker.serviceTypes.map((service: any, serviceIndex: number) => (
                <Box key={`${serviceIndex}-serviceIndex-service-${service.displayName || service.name || "-"}`} className={service.isSelected ? classes.posZoneSelectedBoxStyle : classes.posZoneBoxStyle} onClick={() => selectServiceTypeClick(marker, serviceIndex)}>
                  <Typography className={service.isSelected ? classes.posZoneSelectedBoxSpanStyle : classes.posZoneBoxSpanStyle}>{`${service.displayName || service.name || "-"}`}</Typography>
                </Box>
              ))}
            {marker.selectedServiceDetails && isNonEmptyObject(marker.selectedServiceDetails) && (
              <>
                <Grid item xs={12} className={classes.polygonInfoWindowMainGridItemStyle}>
                  <Typography className={classes.polygonInfoWindowTitleTextStyle}>{`Zones Serving`}</Typography>
                </Grid>
                {!isEmptyOrNull(marker?.selectedServiceDetails?.zones) && marker?.selectedServiceDetails?.zones?.map((zone: any, zoneIndex: number) => (
                  <Box key={`${zoneIndex}-zoneIndex-zone-${zone.name || "-"}`} className={zone.isSelected ? classes.posZoneSelectedBoxStyle : classes.posZoneBoxStyle} onClick={() => selectServiceZoneTypeClick(marker, zone, zoneIndex)}>
                    <Typography className={zone.isSelected ? classes.posZoneSelectedBoxSpanStyle : classes.posZoneBoxSpanStyle}>{`${zone.name || "-"}`}</Typography>
                  </Box>
                ))}
              </>
            )}
          </Grid>
        </Box>
      </div>
    </ClickAwayListener>
  );
};

interface ChangeConfigOtionProps {
  is_edit_mode: any;
  classes: any;
  use_existing_config_change_handler: any;
  use_existing_checked: any;
  change_existing_checked: any;
  use_change_existing_config_change_handler: any;
}

export const ChangeConfigOtion = (props: ChangeConfigOtionProps) => {
  const { classes, is_edit_mode, use_existing_config_change_handler, use_existing_checked, change_existing_checked, use_change_existing_config_change_handler } = props;

  return (
    <Grid item xs={12} className={classes.dFlexEnd}>
      {is_edit_mode ? (
        <FormControlLabel
          onClick={(e) => e.stopPropagation()}
          control={
            <Checkbox
              className={classes.switchStyle}
              checked={change_existing_checked}
              onChange={use_change_existing_config_change_handler}
            />
          }
          label={<Typography className={classes.dlvFeeCalculationTextStyle}>Change existing configuration</Typography>}
        />
      ) : (
        <FormControlLabel
          onClick={(e) => e.stopPropagation()}
          control={
            <Checkbox
              className={classes.switchStyle}
              checked={use_existing_checked}
              onChange={use_existing_config_change_handler}
            />
          }
          label={<Typography className={classes.dlvFeeCalculationTextStyle}>Use existing configuration</Typography>}
        />
      )}
    </Grid>
  );
};

export const EmptyIcon = () => <></>;